import { User } from "../../interface/user.interface";
import { encrypt, redirectToCotizadorIfNeeded } from "../../util/General";
import axios, { AxiosRequestConfig } from "axios";
import { routes } from "../../gen/General";
import { do_login } from "../actions";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useBoolean } from "../../custom-hooks/useBoolean";
import { RefObject, useState } from "react";
import { Alert } from "../../interface/alert.interface";
import { TotpValidationFormProps } from "../mfa-authentication/TotpValidationModal";
import { FIRST_TIME_LOGIN } from "../../components/prodeseg-dropdown/prodeseg-dropdown.constants";

interface AuthenticationSuccessResponse {
    user: User;
    roles: string[];
    config: Record<string, string>;
}

interface UseLoginProps {
    alert: RefObject<Alert>;
}

export const useLogin = ({ alert }: UseLoginProps) => {
    const { value: needTotpValidation, setTrue: setNeedTotpValidation } = useBoolean();
    const [valuesToTotpValidation, setValuesToTotpValidation] = useState<TotpValidationFormProps>();
    const dispatch = useDispatch();
    const history = useHistory();
    const params = useParams<{ hash?: string }>();

    const getAsociados = (response: AuthenticationSuccessResponse) => {
        Promise.all([
            axios.post(routes.base + "/enki/asociados", { cdAdicional: response.user.id }),
            axios.post(routes.apiVam + "/enki/asociados", { cdAdicional: response.user.id }),
        ])
            .then(function (values) {
                onLoginSucess({
                    ...response.user,
                    asociados: values[0].data,
                    asociadosVam: values[1].data,
                    roles: response.roles,
                });
            })
            .catch(alert?.current?.handle_error);
    };

    const onLoginSucess = (data: User) => {
        dispatch(do_login(data));
    };

    const saveLogin = (data: { enki: string; perseo: string }) => {
        if (params.hash) {
            localStorage.setItem("uqai", encrypt(data));
        }
    };

    const requestAuthentication = async (username: string, password: string, headers: Record<string, unknown> = {}) => {
        const requestConfig: AxiosRequestConfig = {
            auth: { username, password },
            headers,
        };

        return axios
            .post(routes.base + "/enki", {}, requestConfig)
            .then(response => {
                // hay respuesta exitosa desde el server, si se inicio sesión
                //lanzo accion con los datos del usuario
                getAsociados(response.data);

                if (!response.data.user.fcCambioClave) {
                    history.push("/perfil?iris=true");
                } else {
                    sessionStorage.setItem(FIRST_TIME_LOGIN, "true");
                    saveLogin({ enki: username, perseo: password });
                    redirectToCotizadorIfNeeded();
                    if (params.hash) history.push("/");
                }
            })
            .catch(error => {
                alert?.current?.handle_error(error);
                const responseHeaders = error.response.headers;
                if (responseHeaders && responseHeaders["x-totp"]) {
                    setNeedTotpValidation();
                    setValuesToTotpValidation({
                        needConfiguration: responseHeaders["x-totp"] === "CONFIG",
                        username,
                        password,
                        qrCode: responseHeaders["x-totp-qr"],
                        daysToExpireCookie: responseHeaders["x-time-to-expire-cookie"],
                        alert: alert,
                    });
                }
                dispatch(do_login({ username: null, id: null }));
            });
    };

    return {
        needTotpValidation,
        valuesToTotpValidation,
        requestAuthentication,
    };
};
